var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-7 4a7 7 0 1 1 11.796 5.098 11.01 11.01 0 0 1 6.068 8.168 1.5 1.5 0 1 1-2.964.47 8.003 8.003 0 0 0-15.8 0 1.501 1.501 0 0 1-2.964-.472A11.02 11.02 0 0 1 6.704 16.1 6.98 6.98 0 0 1 4.5 11m18-3a1.5 1.5 0 1 0 0 3 3 3 0 0 1 1.332 5.688A1.5 1.5 0 0 0 23 18.032v.704a1.5 1.5 0 0 0 1.148 1.46c2.4.578 4.324 2.4 5.044 4.744a1.501 1.501 0 0 0 2.762.266 1.5 1.5 0 0 0 .106-1.146 10.02 10.02 0 0 0-5.12-6.024A6 6 0 0 0 22.5 8",
    clipRule: "evenodd"
  })));
};
export default SvgPeople;